export default {
  getExtensionFeedback: (state) => state.extensionFeedback,
};
